import {ChangeDetectionStrategy, Component, Input, ViewEncapsulation} from '@angular/core';
import {CtiPiece} from '../../../../shared/models/cti-piece';
import {CtiPuzzle} from 'src/app/shared/models/cti-puzzle';

@Component({
    selector: 'app-test-cti-examples-test-4',
    templateUrl: './test-cti-examples-test-4.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TestCtiExamplesTest4Component {
    @Input() examples: CtiPuzzle[] = null;
    @Input() solutions: CtiPiece[][] = null;
}
